export const fieldTagStyles = {
  width: "170px",
  height: "32px",
  "border-radius": "4px",
};
